import React from 'react';
import Tabs from './Tabs';
import {formatAsOrdinal} from '../../services/util';
import { tooltipTypes, Tooltip } from './Tooltip';

export default class PercentageTabs extends React.Component {
  constructor (props){
    super(props);
  }

  getPercentageLabel(rawPercentage, label){
    let tooltip = this.getLabelTooltip(label);
    let percentage = rawPercentage && Math.round(rawPercentage);
    if(percentage){
      if(percentage > 100){
        percentage = 100;
      }
      let dynamicWidthStyle = {
        width: percentage + "%",
      };
      let progressBarClass = "progressBar";
      let percentageClass = "percentage";
      if(this.props.cutoffs && this.props.cutoffs.okay && this.props.cutoffs.good) {
        if(rawPercentage < this.props.cutoffs.okay){
          progressBarClass += " bad";
          percentageClass += " bad";
        }else if(rawPercentage >= this.props.cutoffs.good){
          progressBarClass += " good";
        } else {
          progressBarClass += " okay";
        }
      }
      return(
        <div className="percentageLabel">
          <div className="label">{label}{tooltip}</div>
          <div className={percentageClass}>{formatAsOrdinal(percentage)}</div>
          <div className="units">percentile</div>
          <div className="progressBarContainer">
            <div className={progressBarClass} style={dynamicWidthStyle}/>
          </div>
        </div>
      );
    } else {
      return(
        <div className="percentageLabel">
          <div className="label">{label}{tooltip}</div>
        </div>
      );
    }
  }

  formatPercentageLabels(){
    return this.props.tabs.map((tab)=> {
      let percentage = tab.tab && tab.tab.percentage;
      let label = tab.tab && tab.tab.label;
      return({
        tab: this.getPercentageLabel(percentage, label),
        content: tab.content,
      });
    });
  }

  getLabelTooltip(label) {
    switch (label) {
      case 'Phonological Awareness':
        return (
          <Tooltip type={tooltipTypes.phonologicalAwareness} />
        )
      case 'High Frequency Words':
        return (
          <Tooltip type={tooltipTypes.sightRecognition} />
        )
      case 'Vocabulary':
        return (
          <Tooltip type={tooltipTypes.vocabulary} />
        )
      case 'Decoding':
        return (
          <Tooltip type={tooltipTypes.decoding} />
        )
    }
  }

  render() {
    let tabs = this.formatPercentageLabels();
    return (
      <Tabs tabs={tabs} scrollable={true}/>
    );
  }
}
